import * as React from 'react'
import { Check as CheckIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface CheckProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md'
}

const sizeMap = { sm: 'h-5 w-5', md: 'h-6 w-6' }
const iconSize = { sm: 12, md: 14 }

export const Check = React.forwardRef<HTMLDivElement, CheckProps>(
  ({ className, size = 'md', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center shrink-0 rounded-full bg-[rgba(43,90,255,0.1)] text-blue',
        sizeMap[size],
        className,
      )}
      {...props}
    >
      <CheckIcon size={iconSize[size]} strokeWidth={2.5} />
    </div>
  ),
)
Check.displayName = 'Check'
